import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=287dd9d6&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=287dd9d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287dd9d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('287dd9d6')) {
      api.createRecord('287dd9d6', component.options)
    } else {
      api.reload('287dd9d6', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=287dd9d6&scoped=true&", function () {
      api.rerender('287dd9d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/order_manage/international_division/form/detail.vue"
export default component.exports